import React from "react";

import "../Styles/Edit.css";

import { useEffect } from "react";
import { useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import "../Styles/Add.css";
import axios from "axios";
import Cookies from "js-cookie";

export default function Edit() {
    const { id } = useParams();
    const [categories, setCategories] = useState([]);
    const [recipe, setRecipe] = useState({});
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const navigate = useNavigate();

    if (!Cookies.get("token")) {
        navigate("/login");
    }

    const addIngredient = (e) => {
        e.preventDefault();
        if (document.activeElement !== e.target) return;
        let newRecipe = recipe;
        newRecipe.Ingredients.push("");
        setRecipe(newRecipe);
        setReload(!reload);
    }
    
    const addStep = (e) => {
        e.preventDefault();
        if (document.activeElement !== e.target) return;
        let newRecipe = recipe;
        newRecipe.Steps.push("");
        setRecipe(newRecipe);
        setReload(!reload);
    }


    function addTag(e) {
        e.preventDefault();
        if (document.activeElement !== e.target) return;
        let newRecipe = recipe;
        newRecipe.Tags.push("");
        setRecipe(newRecipe);
        setReload(!reload);
    }


    function updateFormData(e) {
        const form = e.target.form;
        const data = new FormData(form);
        let newRecipe = recipe;
        newRecipe.Title = data.get("title");
        newRecipe.Ingredients = data.getAll("ingredient");
        newRecipe.Steps = data.getAll("step");
        newRecipe.Temps = data.get("time");
        newRecipe.personnes = data.get("people");
        newRecipe.Tags = data.getAll("tag");
        newRecipe.Category_id = data.get("category");
        setRecipe(newRecipe);
    }

    function sendRecipe(e) {
        e.preventDefault();
        let formData = new FormData();
        formData.append("id", id);
        formData.append("title", recipe.Title);
        let filteredIngredients = recipe.Ingredients.filter((ingredient) => ingredient !== "");
        formData.append("ingredients", filteredIngredients.join(""));
        let filteredSteps = recipe.Steps.filter((step) => step !== "");
        formData.append("steps", filteredSteps.join(""));
        formData.append("time", recipe.Temps);
        formData.append("people", recipe.personnes);
        let filteredTags = recipe.Tags.filter((tag) => tag !== "");
        console.log(filteredTags);
        formData.append("tags", filteredTags.join(","));
        formData.append("category", recipe.Category_id);
        formData.append("token", Cookies.get("token"));
        axios.post("https://anatole-sot.xyz/api/recettes-gibli/update-recipe.php", formData, {headers: {"Content-Type": "multipart/form-data"}})
        .then((response) => {
            if (response.data.status === "success") {
                alert("Votre recette a bien été mise à jour");
                navigate("/recipes/"+response.data.data.recipe_id);
            } else {
                alert(response.data.data);
            }
        }
        )
        .catch((error) => {
            console.log(error);
        }
        )
    }


    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-categories.php")
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setCategories(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }, []);
    
    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-recipe.php?id=" + id)
        .then((response) => {
            if (response.data.status === "success") {
                setRecipe(response.data.data);
                setLoading(false);
            } else {
                if (response.data.data === "Recipe not found") {
                    navigate("/404");
                }
            }
        })
        .catch((error) => {
            console.log(error);
        })
        }, [id,navigate]);

    if (loading) {
        return (
            <div className="Edit">
                <h1>Edit Recipe</h1>
                <p>Loading...</p>
            </div>
        );
    }
    return (
        <div className="Edit">
            <h1>Modifier la recette : </h1>
            <form onInput={updateFormData}>
                <label htmlFor="title">Nom de la recette</label>
                <input type="text" id="title" name="title" defaultValue={recipe.Title} required/>
                
                <div className="infos">
                    
                    <div>
                        <div>
                            <input type="number" id="time" name="time" defaultValue={recipe.Temps} required/>
                            <span className="emoji">⏱️</span>
                        </div>
                    </div>
                    
                    <div>
                        <label htmlFor="category">Catégorie</label>
                        <select id="category" defaultValue={recipe.Category_id} name="category" required>
                            {categories.map((category, index) => {
                                return (
                                    <option key={index} value={category.ID}>{category.Name}</option>
                                );
                            })
                            }
                        </select>
                    </div>
                    <div>
                        <div>
                            <input type="number" id="people" name="people" defaultValue={recipe.personnes} required/>
                            <span className="emoji">👤</span>
                        </div>
                    </div>
                    
                </div>


                <label htmlFor="ingredients">Ingrédients</label>
                <ul>
                {recipe.Ingredients.map((ingredient, index) => {
                    return (
                        <li key={index}>
                            <input type="text" name="ingredient" defaultValue={ingredient} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ul>
                <button onClick={addIngredient}>Ajouter un ingrédients</button>
                
                <label htmlFor="steps">Étapes</label>
                <ol>
                {recipe.Steps.map((step, index) => {
                    return (
                        <li key={index}>
                            <textarea type="text" name="step" defaultValue={step} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ol>
                <button onClick={addStep}>Ajouter une étape</button>
                
                <label htmlFor="tags">Tags</label>
                <ul>
                {recipe.Tags.map((tag, index) => {
                    return (
                        <li key={index}>
                            <input type="text" name="tag" defaultValue={tag.Name} data-index={index} required/>
                        </li>
                    );
                })
                }
                </ul>
                <button onClick={addTag}>Ajouter un tag</button>
                <button type="submit" onClick={sendRecipe}>Mettre à jour la recette</button>
            </form>
        </div>
    );
}